import { __extends } from "tslib";
import { AssetBase } from '@awayjs/core';
/**
 *
 */
var ImageSampler = /** @class */ (function (_super) {
    __extends(ImageSampler, _super);
    /**
     *
     */
    function ImageSampler(repeat, smooth, mipmap) {
        if (repeat === void 0) { repeat = false; }
        if (smooth === void 0) { smooth = false; }
        if (mipmap === void 0) { mipmap = false; }
        var _this = _super.call(this) || this;
        _this._repeat = repeat;
        _this._smooth = smooth;
        _this._mipmap = mipmap;
        return _this;
    }
    Object.defineProperty(ImageSampler.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return ImageSampler.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageSampler.prototype, "repeat", {
        /**
         *
         */
        get: function () {
            return this._repeat;
        },
        set: function (value) {
            if (this._repeat == value)
                return;
            this._repeat = value;
            //TODO: update dependencies
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageSampler.prototype, "smooth", {
        /**
         *
         */
        get: function () {
            return this._smooth;
        },
        set: function (value) {
            if (this._smooth == value)
                return;
            this._smooth = value;
            //TODO: update dependencies
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageSampler.prototype, "mipmap", {
        /**
         *
         */
        get: function () {
            return this._mipmap;
        },
        set: function (value) {
            if (this._mipmap == value)
                return;
            this._mipmap = value;
            //TODO: update dependencies
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageSampler.prototype, "imageRect", {
        /**
         *
         */
        get: function () {
            return this._imageRect;
        },
        set: function (value) {
            if (this._imageRect == value)
                return;
            this._imageRect = value;
            this._updateRect();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageSampler.prototype, "frameRect", {
        /**
         *
         */
        get: function () {
            return this._frameRect;
        },
        set: function (value) {
            if (this._frameRect == value)
                return;
            this._frameRect = value;
            this._updateRect();
        },
        enumerable: true,
        configurable: true
    });
    ImageSampler.prototype._updateRect = function () {
    };
    ImageSampler.assetType = '[asset Sampler]';
    return ImageSampler;
}(AssetBase));
export { ImageSampler };
